import { render, staticRenderFns } from "./sony-brand.vue?vue&type=template&id=698091ef"
import script from "./sony-brand.vue?vue&type=script&lang=js"
export * from "./sony-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports